import { post } from "../base";
import { ClientRequest } from "../ClientRequest.js";
import { ClientResponse } from "../ClientResponse";
import { Petition } from "../Petition.js";
import { PATH } from "@/utils/shared";
import TYPE from "../types";

const API_SERVICE_DATA_OBTENER = "/api/ServiceGeoserver/V1/procesar";
const API_SERVICE_DATA_PROCESAR = "/api/ServiceData/V1/procesar";

export default {
  addOne: (idtipoficha, idtipoformalizacion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    _petition.type = _type;
    _petition.table = "cat_ficha";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("idtipoficha", idtipoficha);
    _petition.add_item("idtipoformalizacion", idtipoformalizacion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addOneProcedureFichaIndividual: (usuario) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_function_iniciar_fichaindividual");
    _petition.add_item("USUARIO", usuario);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addModificacion: (idficha, observacion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    _petition.type = _type;
    _petition.table = "cat_modificar";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("idficha", idficha);
    _petition.add_item("descripcion", observacion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  changeState: (idficha, activo) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficha";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("firmado", activo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOne: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficha";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneDatoRural: (idtitular) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idtitularrural = " + idtitular;

    _petition.type = _type;
    _petition.table = "cat_titularrural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneDatoCotitular: (idtitular) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idtitular = " + idtitular;

    _petition.type = _type;
    _petition.table = "cat_titular";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneFicha: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_geoserver_delete_ficha");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_GEOSERVER";

    return post(PATH.API_SERVICE, _request);
  },

  editInformacionComplementariaEconomica: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaeconomica";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("observacion", payload.observacion);
    _petition.add_itemFilter("otrodocumentopresentado", payload.otrodocumentopresentado);
    _petition.add_itemFilter("otrocondiciondeclarante", payload.otrocondiciondeclarante);
    _petition.add_itemFilter("idcondiciondeclarante", payload.idcondiciondeclarante);
    _petition.add_itemFilter("iddocumentopresentado", payload.iddocumentopresentado);
    _petition.add_itemFilter("idestadollenado", payload.idestadollenado);
    _petition.add_itemFilter("idmantenimiento", payload.idmantenimiento);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addOneTypeFicha: (idficha, typefichadbtable) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "sp_insert_ficha_economica");
    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("TABLA", typefichadbtable, "int");

    _request.petitions.push(_petition);

    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  calculaMaxNumeroFicha: (idtipoficha) => {
    var _request = new ClientRequest();
    var _response = new ClientResponse();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_calcula_max_nroficha");
    _petition.add_item("@IDTIPOFICHA", idtipoficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return _response._generate(post(PATH.API_SERVICE, _request));
  },

  setNumeroFicha: (idficha, numeroficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficha";
    _petition.condition = _condition;
    _petition.transaction = false;
    _petition.add_item("numeroficha", numeroficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  updateField: ({ idficha, columna, valor }) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficha";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item(columna, valor);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteEntidad: (identidad, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaeconomica";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("identidadconductor", "null", "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteEntidadJuridica: (identidad, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaeconomica";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("identidadconductorjuridica", "null", "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getCodigoCatastralByFicha: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_codigounico");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);

    // eslint-disable-next-line no-redeclare
    _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_archivos_fichas");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);

    _petition = new Petition();

    _petition.add_item("script", "sp_syca_mantenimiento_codigounico_insert");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);

    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getArchivosFichas: (idficha) => {
    var _request = new ClientRequest();

    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_archivos_fichas");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);

    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllDepartamentos: () => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_departamento");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllProvincias: (filtro) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_provincia");
    _petition.add_item("IDPADRE", filtro);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllDistritos: (filtro) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_distrito");
    _petition.add_item("IDPADRE", filtro);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getSectores: () => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_select_sector");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getManzanas: (idsector) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_select_manzana");
    _petition.add_item("IDSECTOR", idsector);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getLotes: (idmanzana) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_select_lote");
    _petition.add_item("IDMANZANA", idmanzana);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getInformacionFicha: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_informacion_ficha");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditCodigoCatastral: (payload, idcodigounico) => {

    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = 2;
    var _condition = "";

    if (idcodigounico) {
      _type = TYPE.UPDATE;
      _condition = "idcodigounico = " + idcodigounico;
    }

    _petition.type = _type;
    _petition.table = "cat_codigounico";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("denominacion", payload.uniquecode + payload.codigodc);
    _petition.add_itemFilter("codigounicocatastral", payload.codigounicocatastral);
    _petition.add_itemFilter("codigohojacatastral", payload.codigohojacatastral);
    _petition.add_itemFilter("codigocontribuyenterenta", payload.codigocontribuyenterenta);
    _petition.add_itemFilter("codigopredialrenta", payload.codigopredialrenta);
    _petition.add_itemFilter("codigoedifica", payload.codigoedifica);
    _petition.add_itemFilter("codigoentrada", payload.codigoentrada);
    _petition.add_itemFilter("codigopiso", payload.codigopiso);
    _petition.add_itemFilter("codigounidad", payload.codigounidad);
    _petition.add_itemFilter("codigodc", payload.codigodc);
    _petition.add_itemFilter("codigozona", payload.codigozona);
    _petition.add_itemFilter("codigocoordenadaeste", payload.codigocoordenadaeste);
    _petition.add_itemFilter("codigocoordenadanorte", payload.codigocoordenadanorte);
    _petition.add_itemFilter("codigounidadorganicacatastral", payload.codigounidadorganicacatastral);
    _petition.add_itemFilter("codigounidadcatastral", payload.codigounidadcatastral);
    _petition.add_itemFilter("idlote", payload.idlote);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  actualizarLoteCatastral: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = 2;
    var _condition = "";

    _type = 5;
    _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "utm_84_lotes";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemWithNulo("isformal", payload.idtipoformalizacion);
    _petition.add_itemWithNulo("tipoficha", payload.tipoficha);
    _petition.add_itemWithNulo("islitigio", payload.litigio);
    _petition.add_itemWithNulo("idhaburbana", payload.idhabilitacionurbana);
    _petition.add_itemWithNulo("lote", payload.codigo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_GEOSERVER";

    return post(PATH.API_SERVICE, _request);
  },

  addObtenerInfoFicha: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_select_lote");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  asignCodUnicoAFicha(idficha, idcodigounico) {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficha";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemSelect("idcodigounico", idcodigounico);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getTipoCatalogo: (idtipocatalogo) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_select_catalogo");
    _petition.add_item("IDTIPOCATALOGO", idtipocatalogo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  fichaEconomicaAddEntidad: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaeconomica";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("identidadconductor", payload.identidad);
    _petition.add_itemFilter("otrocondicionconductor", payload.otrocondicionconductor);
    _petition.add_itemFilter("otrodocumentopresentado", payload.otrodocumentopresentado);
    _petition.add_itemFilter("nombrecomercial", payload.nombrecomercial);
    _petition.add_itemFilter("idcondicionconductor", payload.idcondicionconductor);
    _petition.add_itemFilter("idtipodocumentoregistroconductor",payload.idtipodocumentoregistroconductor);
    _petition.add_itemFilter("identidadconductorjuridica", payload.identidadconductorjuridica);
    _petition.add_itemFilter("idtipoconductor", payload.idtipoconductor);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getOneEntidadEconomica: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_fichaeconomica_all_ope_entidad");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getOneFichaEcnomica: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_distrito_ficha_economica_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditAnuncioOne: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = 2;
    var _condition = "";

    if (payload.idanuncio.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idanuncio = " + payload.idanuncio;

    } 

    _petition.add_itemFilter("numerolado", payload.numerolado);
    _petition.add_itemFilter("areaautorizada", payload.areaautorizada);
    _petition.add_itemFilter("areaverificada", payload.areaverificada);
    _petition.add_itemFilter("idtipoanuncio", payload.idtipoanuncio);
  
    _petition.type = _type;
    _petition.table = "cat_anuncio";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("numeroexpediente", payload.numeroexpediente);
    _petition.add_itemFilter("numerolicencia", payload.numerolicencia);
    _petition.add_itemFilter("fechaexpedicion", payload.fechaexpedicion);
    _petition.add_itemFilter("fechavencimiento", payload.fechavencimiento);
    _petition.add_itemFilter("idficha", payload.idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getFichaEconomicaAnuncio: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_economica_obtener_anuncio");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditAutorizacion: (payload, idfuncionamiento) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = 2;
    var _condition = "";

    if (idfuncionamiento.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idfuncionamiento = " + idfuncionamiento;

    } 
     
    _petition.add_itemFilter("idactividadeconomica", payload.idactividadeconomica);
    
    _petition.type = _type;
    _petition.table = "cat_funcionamiento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("actividadeconomica", payload.actividadeconomica);
    _petition.add_itemFilter("idficha", payload.idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllAutorizacion: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_cat_funcionamiento");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteAutorizacion: (idfuncionamiento) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idfuncionamiento = " + idfuncionamiento;

    _petition.type = _type;
    _petition.table = "cat_funcionamiento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editMunicipalFuncionamiento: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaeconomica";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("predioareaautorizado", payload.predioareaautorizado);
    _petition.add_itemFilter("predioareaverificado", payload.predioareaverificado);
    _petition.add_itemFilter("viaareaautorizado", payload.viaareaautorizado);
    _petition.add_itemFilter("viaareaverificado", payload.viaareaverificado);
    _petition.add_itemFilter("biencomunareaautorizado", payload.biencomunareaautorizado);
    _petition.add_itemFilter("biencomunareaverificado", payload.biencomunareaverificado);

    _petition.add_itemFilter("nroexpediente", payload.nroexpediente);
    _petition.add_itemFilter("nrolicencia", payload.nrolicencia);
    _petition.add_itemFilter("fechainicioactividad", payload.fechainicioactividad);
    _petition.add_itemFilter("fechaexpedicion", payload.fechaexpedicion);
    _petition.add_itemFilter("fechavencimiento", payload.fechavencimiento);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneFichaEconomicaDireccion: (payload, iddirecciondomiciliofiscal, idficha) => {

    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";
    var _token = "";

    if (iddirecciondomiciliofiscal.toString().length > 0) {
      _type = TYPE.UPDATE;
      _condition = "iddireccion = " + iddirecciondomiciliofiscal;
    } 

    _petition.add_itemFilter("idubicaciongeografica", payload.idubicaciongeografica);
    _petition.add_itemFilter("idhabilitacionurbana", payload.idhabilitacionurbana);
  
    _token = _petition.token;

    _petition.type = _type;
    _petition.table = "ads_direccion";
    _petition.condition = _condition;
    _petition.transaction = false;

    //_petition.add_item("nombreedificacion", payload.nombreedificacion);
    _petition.add_itemFilter("via", payload.via);
    _petition.add_itemFilter("tipovia", payload.tipovia);
    _petition.add_itemFilter("habilitacionurbana", payload.habilitacionurbana);
    _petition.add_itemFilter("sublote", payload.sublote);
    _petition.add_itemFilter("lote", payload.lote);
    _petition.add_itemFilter("manzana", payload.manzana);
    _petition.add_itemFilter("zona", payload.zona);
    _petition.add_itemFilter("idvia", payload.idvia);
    _petition.add_itemFilter("numeromunicipal", payload.numeromunicipal);
    _petition.add_itemFilter("numerointerior", payload.numerointerior);
    _petition.add_itemFilter("nombreedificacion", payload.nombreedificacion);
    _petition.add_itemFilter("telefono", payload.telefono);
    _petition.add_itemFilter("anexo", payload.anexo);
    _petition.add_itemFilter("fax", payload.fax);
    _petition.add_itemFilter("correo", payload.correo);

    _request.petitions.push(_petition);

    if (iddirecciondomiciliofiscal.length <= 0) {
      var c_registro = {
        name: "GetNextId",
        token: _token,
        max_length: 11
      };

      _petition = new Petition();
      _petition.type = TYPE.UPDATE;
      _petition.table = "cat_fichaeconomica";
      _petition.condition = "idficha = " + idficha;

      _petition.add_itemFilter("iddirecciondomiciliofiscal", "", "string", c_registro);
      _request.petitions.push(_petition);
    }

    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  updateFirmante: ({
    columnafirmante,
    identidad,
    columnafecha,
    fecharegistro,
    idficha,
    nroregistroverificador
  }) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficha";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item(columnafirmante, identidad);
    _petition.add_item(columnafecha, fecharegistro);
    _petition.add_item("numeroregistroverificador", nroregistroverificador);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deletefirmante: ({
    columnafirmante,

    idficha
  }) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficha";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item(columnafirmante, "null", "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getFirmantes: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_firmantes_by_idficha");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  /**
   * FICHA INDIVIDUAL
   */

  editPredioCatastralFicha: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaindividual";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("zona", payload.zona);
    _petition.add_itemFilter("manzana", payload.manzana);
    _petition.add_itemFilter("lote", payload.lote);
    _petition.add_itemFilter("sublote", payload.sublote);
    _petition.add_itemFilter("habilitacionurbana", payload.habilitacionurbana);
    _petition.add_itemFilter("numerointerior", payload.numerointerior);
    _petition.add_itemFilter("otrotipointerior", payload.otrotipointerior);

    _petition.add_itemFilter("idhabilitacionurbana", payload.idhabilitacionurbana);
    _petition.add_itemFilter("idtipoedificacion", payload.idtipoedificacion);
    _petition.add_itemFilter("idtipointerior", payload.idtipointerior);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllPredioCatastral: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_prediocatastral_by_idficha");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deletePredioCatastral: (idubicacionprediocatastral) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idubicacionprediocatastral = " + idubicacionprediocatastral;

    _petition.type = _type;
    _petition.table = "cat_ubicacionprediocatastral";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getHabilitacionById: (idhabilitacionurbana) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_habilitacionurbana_all");
    _petition.add_item("IDHABILITACION", idhabilitacionurbana);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getOneFichaInvididual: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_ficha_individual_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getOneFichaInvididualPredio: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_ficha_individual_predio_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addPredioCatastral: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;

    _petition.type = _type;
    _petition.table = "cat_ubicacionprediocatastral";
    _petition.transaction = false;

    _petition.add_itemFilter("via", payload.via);
    _petition.add_itemFilter("tipovia", payload.tipovia);

    _petition.add_itemFilter("idficha", payload.idficha);
    _petition.add_itemFilter("numeromunicipal", payload.numeromunicipal);
    _petition.add_itemFilter("idvia", payload.idvia);

    _petition.add_itemFilter("idtipopuerta", payload.idtipopuerta);
    _petition.add_itemFilter("idcondicionnumeracion", payload.idcondicionnumeracion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editPredioCatastral: (payload, idubicacionprediocatastral) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idubicacionprediocatastral = " + idubicacionprediocatastral;

    _petition.type = _type;
    _petition.table = "cat_ubicacionprediocatastral";
    _petition.transaction = false;
    _petition.condition = _condition;

    _petition.add_itemFilter("via", payload.via);
    _petition.add_itemFilter("tipovia", payload.tipovia);

    _petition.add_itemFilter("idficha", payload.idficha);
    _petition.add_itemFilter("numeromunicipal", payload.numeromunicipal);
    _petition.add_itemFilter("idvia", payload.idvia);

    _petition.add_itemFilter("idtipopuerta", payload.idtipopuerta);
    _petition.add_itemFilter("idcondicionnumeracion", payload.idcondicionnumeracion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  fichaIndividualEditEntidad: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaindividual";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idtipotitular", payload.idtipotitular);
    _petition.add_itemFilter("identidadtitular", payload.identidad);
    _petition.add_itemFilter("identidadconyugue", payload.identidad2);
    _petition.add_itemFilter("identidadpersonajuridica", payload.identidad3);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getObsByFichaIndividual: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_obs_by_ficha_individual");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneObservacion: (payload, idficha, tabla) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = tabla;
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("observacion", payload.observacion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneCaracteristicasTitularidad: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaindividual";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("otrocondiciontitular", payload.otrocondiciontitular);
    _petition.add_itemFilter("otroformaadquisicion", payload.otroformaadquisicion);
    _petition.add_itemFilter("fechaadquisicion", payload.fechaadquisicion);

    _petition.add_itemFilter("idcondiciontitular", payload.idcondiciontitular);
    _petition.add_itemFilter("idformaadquisicion", payload.idformaadquisicion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOnePredioCatastral: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaindividual";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("evaluacioncolidante", payload.evaluacioncolidante);
    _petition.add_item("evaluacionjardin", payload.evaluacionjardin);
    _petition.add_item("evaluacionareapublica", payload.evaluacionareapublica);
    _petition.add_item("evaluacionintangible", payload.evaluacionintangible);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllSunarpById: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_cat_sunarp_by_idficha");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditCatSunarp: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (payload.idsunarp) {
      _type = TYPE.UPDATE;
      _condition = "idsunarp = " + payload.idsunarp;

      _petition.add_itemWithNulo("foja", payload.foja);
      _petition.add_itemWithNulo("asiento", payload.asiento);
      _petition.add_itemWithNulo("iddeclaracionfabrica", payload.iddeclaracionfabrica);
      _petition.add_itemWithNulo("idtipopartidaregistral", payload.idtipopartidaregistral);
      _petition.add_itemWithNulo("fechainscripcion", payload.fechainscripcion);
      _petition.add_itemWithNulo("fechafabrica", payload.fechafabrica);
    } else {
      _petition.add_itemFilter("foja", payload.foja);
      _petition.add_itemFilter("asiento", payload.asiento);
      _petition.add_itemFilter("iddeclaracionfabrica", payload.iddeclaracionfabrica);
      _petition.add_itemFilter("idtipopartidaregistral", payload.idtipopartidaregistral);
      _petition.add_itemFilter("fechainscripcion", payload.fechainscripcion);
      _petition.add_itemFilter("fechafabrica", payload.fechafabrica);
    }

    _petition.type = _type;
    _petition.table = "cat_sunarp";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("numero", payload.numero);
    _petition.add_item("asientofabrica", payload.asientofabrica);
    _petition.add_item("idficha", payload.idficha, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllRespuestas: () => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_select_respuestas_all");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editServiciosBasicosFicha: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaindividual";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idtvcable", payload.idtvcable);
    _petition.add_itemFilter("idinternet", payload.idinternet);
    _petition.add_itemFilter("idgas", payload.idgas);
    _petition.add_itemFilter("idtelefono", payload.idtelefono);
    _petition.add_itemFilter("iddesague", payload.iddesague);
    _petition.add_itemFilter("idagua", payload.idagua);
    _petition.add_itemFilter("idluz", payload.idluz);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneDocumento: (payload, id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (id.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "iddocumentoadjunto = " + id;
    }

    _petition.add_itemFilter("idficha", payload.idficha);
    _petition.add_itemFilter("idtipodocumentoconstruccion", payload.idtipodocumentoconstruccion);
    _petition.add_itemFilter("areaautorizado", payload.areaautorizado);
    _petition.add_itemFilter("documentoregistro", payload.documentoregistro);
    _petition.add_itemFilter("fechadocumento", payload.fechadocumento);

    _petition.type = _type;
    _petition.table = "cat_documentoadjunto";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllDocumentoAdjunto: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_documento_adjunto_by_id");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneDocumento: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "iddocumentoadjunto = " + id;

    _petition.type = _type;
    _petition.table = "cat_documentoadjunto";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllLitigantes: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_all_litigantes");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editInformacionComplementaria: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaindividual";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("otrocondiciondeclarante", payload.otrocondiciondeclarante);
    _petition.add_itemFilter("idcondiciondeclarante", payload.idcondiciondeclarante);
    _petition.add_itemFilter("idestadollenado", payload.idestadollenado);
    _petition.add_itemFilter("idmantenimiento", payload.idmantenimiento);
    _petition.add_itemFilter("numerofamilia", payload.numerofamilia);
    _petition.add_itemFilter("numerohabitante", payload.numerohabitante);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneLitigante: (payload, id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (id.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idlitigante = " + id;

    }

    _petition.add_itemFilter("identidad", payload.identidad);
    _petition.add_itemFilter("idficha", payload.idficha);
    _petition.add_itemFilter("codigocontribuyente", payload.codigocontribuyente);
    
    _petition.type = _type;
    _petition.table = "cat_litigante";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneLitigante: (payload, id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "";

    _condition = "idlitigante = " + id;
    _petition.add_itemWithNulo("eliminado", "1");

    _petition.type = _type;
    _petition.table = "cat_litigante";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllObrasComplementarias: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_all_obras_complementarias");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneObraComplementaria: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idinstalacionobra = " + id;

    _petition.type = _type;
    _petition.table = "cat_instalacionobra";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditObraComplementaria: (payload, id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (id.toString().length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idinstalacionobra = " + id;

    } 
    
    _petition.add_itemFilter("idficha", payload.idficha);
    _petition.add_itemFilter("productototal", payload.productototal);
    _petition.add_itemFilter("idcodigoinstalacion", payload.idcodigoinstalacion);
    _petition.add_itemFilter("fechaconstruccion", payload.fechaconstruccion);
    
    _petition.add_itemFilter("idestadoconservacion", payload.idestadoconservacion);
    _petition.add_itemFilter("idunidadconstruccionantirreglamentaria", payload.idunidadconstruccionantirreglamentaria);
    _petition.add_itemFilter("idmaterialestructural", payload.idmaterialestructural);
    _petition.add_itemFilter("idestadoconstruccion", payload.idestadoconstruccion);

    _petition.add_itemFilter("unidadmedida", payload.unidadmedida);
    _petition.add_itemFilter("codigoinstalacion", payload.codigoinstalacion);

    _petition.type = _type;
    _petition.table = "cat_instalacionobra";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getPorcentajeBienComun: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_porcentaje_bien_comun");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneConstruccion: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idconstruccion = " + id;

    _petition.type = _type;
    _petition.table = "cat_construccion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editPorcentajeBienComun: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaindividual";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("porcentajeterrenolegal", payload.porcentajeterrenolegal);
    _petition.add_itemFilter("porcentajeterrenofisico", payload.porcentajeterrenofisico);
    _petition.add_itemFilter("porcentajeconstruccionlegal", payload.porcentajeconstruccionlegal);
    _petition.add_itemFilter("porcentajeconstruccionfisico", payload.porcentajeconstruccionfisico);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOnePredio: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichaindividual";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("zonificacion", payload.zonificacion);
    _petition.add_itemFilter("frentemedidacampo", payload.frentemedidacampo);
    _petition.add_itemFilter("derechamedidacampo", payload.derechamedidacampo);
    _petition.add_itemFilter("izquierdamedidacampo", payload.izquierdamedidacampo);
    _petition.add_itemFilter("fondomedidacampo", payload.fondomedidacampo);
    _petition.add_itemFilter("fondocolinda", payload.fondocolinda);
    _petition.add_itemFilter("derechacolinda", payload.derechacolinda);
    _petition.add_itemFilter("frentecolinda", payload.frentecolinda);
    _petition.add_itemFilter("izquierdacolinda", payload.izquierdacolinda);
    _petition.add_itemFilter("otroprediocatastral", payload.otroprediocatastral);
    _petition.add_itemFilter("areaterrenoverificado", payload.areaterrenoverificado);
    _petition.add_itemFilter("areaterrenoadquirido", payload.areaterrenoadquirido);
    _petition.add_itemFilter("idprediocatastral", payload.idprediocatastral);
    _petition.add_itemFilter("idclasificacionpredio", payload.idclasificacionpredio);
    _petition.add_itemFilter("otroclasificacionpredio", payload.otroclasificacionpredio);
    
    _petition.add_itemFilter("iduso", payload.iduso);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  
  addEditOneFichaIndividualDireccion: (payload, iddirecciondomiciliofiscal, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "";

    _condition = "iddireccion = " + iddirecciondomiciliofiscal;

    _petition.type = _type;
    _petition.table = "ads_direccion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idubicaciongeografica", payload.idubicaciongeografica);
    _petition.add_itemFilter("idhabilitacionurbana", payload.idhabilitacionurbana);
    _petition.add_itemFilter("nombreedificacion", payload.nombreedificacion);
    _petition.add_itemFilter("via", payload.via);
    _petition.add_itemFilter("tipovia", payload.tipovia);
    _petition.add_itemFilter("habilitacionurbana", payload.habilitacionurbana);
    _petition.add_itemFilter("sublote", payload.sublote);
    _petition.add_itemFilter("lote", payload.lote);
    _petition.add_itemFilter("manzana", payload.manzana);
    _petition.add_itemFilter("zona", payload.zona);

    _petition.add_itemFilter("telefono", payload.telefono);
    _petition.add_itemFilter("anexo", payload.anexo);
    _petition.add_itemFilter("correo", payload.email);

    _petition.add_itemFilter("idvia", payload.idvia, "int");
    _petition.add_item("numerointerior", payload.numerointerior);
    _petition.add_item("numeromunicipal", payload.numeromunicipal);

    _request.petitions.push(_petition);

    // var c_registro = {
    //   name: "GetNextId",
    //   token: _token,
    //   max_length: 11
    // };

    _petition = new Petition();
    _petition.type = TYPE.UPDATE;
    _petition.table = "cat_fichaindividual";
    _petition.condition = "idficha = " + idficha;

    _petition.add_itemFilter("idubicaciondomiciliofiscal", payload.idubicaciondomiciliofiscal);
    _petition.add_itemFilter("iddirecciondomiciliofiscal",payload.iddirecciondomiciliofiscal);
    _petition.add_itemFilter("otroubicaciondomiciliofiscal", payload.otroubicaciondomiciliofiscal);

    _request.petitions.push(_petition);

    if(payload.idvia)
    {
      _petition = new Petition();
      _petition.type = TYPE.UPDATE;
      _petition.table = "ads_via";
      _petition.condition = "idvia = " + payload.idvia;

      _petition.add_itemFilter("idtipovia", payload.idtipovia);

      _request.petitions.push(_petition);
    }


    // if (payload.identidadtitular.length > 0) {
    //   _petition = new Petition();
    //   _petition.type = TYPE.UPDATE;
    //   _petition.table = "ope_entidad";
    //   _petition.condition = "identidad = " + payload.identidadtitular;

    //   _petition.add_item("telefono", payload.telefono);
    //   _petition.add_item("celular", payload.celular);
    //   _petition.add_item("email", payload.email);
    //   _petition.add_item("anexo", payload.anexo);
    //   _request.petitions.push(_petition);
    // }

    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getOneEntidadById: (identidad) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_entidad_by_identidad");
    _petition.add_item("IDENTIDAD", identidad);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllCoordenadas: (idficha, islitigio) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    islitigio == 0
      ? _petition.add_item("script", "q_syca_obtener_all_coordenadas")
      : _petition.add_item("script", "q_syca_obtener_all_litigante_coordenadas");

    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("ISLITIO", islitigio);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditCoordenada: (payload, id, islitigio) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    // id puede venir como numero desde el backend (no siempre string), por eso
    // se compara con String() en vez de usar id.length directo.
    if (String(id ?? "").length > 0) {
      _type = TYPE.UPDATE;

      islitigio == 0
        ? (_condition = "idcoordenada = " + id)
        : (_condition = "idlitigantecoordenada = " + id);
    }

    _petition.add_itemFilter("este", payload.este);
    _petition.add_itemFilter("norte", payload.norte);
    _petition.add_itemFilter("idficha", payload.idficha);

    _petition.type = _type;

    islitigio == 0
      ? (_petition.table = "cat_coordenada")
      : (_petition.table = "cat_litigantecoordenada");

    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneCoordenada: (record, islitigio) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "";

    if (islitigio == 0) {
      _condition = "idcoordenada = " + record.idcoordenada;
      _petition.table = "cat_coordenada";
    } else {
      _condition = "idlitigantecoordenada = " + record.idlitigantecoordenada;
      _petition.table = "cat_litigantecoordenada";
    }

    _petition.type = _type;
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  procesarCoordenadas: (idficha) => {
    const request = {
      _type: TYPE.EXECUTE,
      _table: "cat_coordenada",
      idficha: idficha,
      _petitions: []
    };
    return post(PATH.API_PROCESAR, request);
  },

  obtenerCoordenadas: (idficha, islitigio) => {
    const request = {
      _type: TYPE.EXECUTE,
      _table: "cat_coordenada",
      idficha: idficha,
      _petitions: []
    };
    return post(API_SERVICE_DATA_OBTENER + "/" + idficha + "/" + islitigio, request);
  },

  procesar: (idficha, islitigio) => {
    const request = {
      _type: 4,
      _table: "cat_coordenada",
      idficha: idficha,
      _petitions: []
    };
    return post(API_SERVICE_DATA_PROCESAR + "/" + idficha + "/" + islitigio, request);
  },

  /**
   * END FICHA INDIVIDUAL
   */

  /**
   * FICHA COTITULAR
   */

  getOneFichaCotitular: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_registro_select_ficha_cotitular");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getOneFichaCotitularRural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_registro_select_ficha_cotitular_rural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllTitular: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_obtener_cotitular_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllTitularRuralCotitular: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_obtener_cotitular_rural_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getOneWithTipoEntidad: (documentoregistro) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_select_entidad_all");
    _petition.add_item("DOCUMENTOREGISTRO", documentoregistro);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneWithNulos: (payload, identidadtitular) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    _petition.type = _type;
    _petition.table = "ope_entidad";
    _petition.condition = _condition;
    _petition.transaction = false;

    if (identidadtitular.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "identidad = " + identidadtitular;
    }

    _petition.add_item("apellidopaterno", payload.apellidopaterno);
    _petition.add_item("apellidomaterno", payload.apellidomaterno);
    _petition.add_item("nombre", payload.nombre);
    _petition.add_item("documentoregistro", payload.documentoregistro);
    _petition.add_item("email", payload.email);
    _petition.add_item("celular", payload.celular);
    _petition.add_item("anexo", payload.anexo);
    _petition.add_item("telefono", payload.telefono);

    _petition.add_item("idestadocivil", payload.idestadocivil, "int");
    _petition.add_item("idsexo", payload.idsexo, "int");
    _petition.add_item("idtipodocumentoregistro", payload.idtipodocumentoregistro, "int");
    _petition.add_item("idtipopersonajuridica", payload.idtipopersonajuridica, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editTipoJuridica: (payload, identidadtitular) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "identidad = " + identidadtitular;

    _petition.type = _type;
    _petition.table = "ope_entidad";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idtipopersonajuridica", payload.idtipopersonajuridica, "int");
    _petition.add_itemFilter("otrotipopersonajuridica", payload.otrotipopersonajuridica);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

   editOneDireccion: (payload, iddomiciliofiscal) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (iddomiciliofiscal) {
      _type = TYPE.UPDATE;
      _condition = "iddireccion = " + iddomiciliofiscal;
    }

    _petition.add_item("zona", payload.zona);
    _petition.add_item("manzana", payload.manzana);
    _petition.add_item("lote", payload.lote);
    _petition.add_item("sublote", payload.sublote);
    _petition.add_item("nombreedificacion", payload.nombreedificacion);
    _petition.add_item("numeromunicipal", payload.numeromunicipal);
    _petition.add_item("numerointerior", payload.numerointerior);

    _petition.add_item("idvia", payload.idvia, "int");
    _petition.add_item("idubicaciongeografica", payload.idubicaciongeografica, "int");
    _petition.add_item("idhabilitacionurbana", payload.idhabilitacionurbana, "int");
    /*_petition.add_item("iddirecciondomiciliofiscal", payload.iddirecciondomiciliofiscal, "int");*/

    _petition.type = _type;
    _petition.table = "ads_direccion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  edittitularOne: (payload, idtitular) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (idtitular) {
      _type = TYPE.UPDATE;
      _condition = "idtitular = " + idtitular;

      _petition.add_item("numerocotitular", payload.numerocotitular, "string");
      _petition.add_item("otroformaadquisicion", payload.otroformaadquisicion, "string");
      _petition.add_item("codigocontribuyente", payload.codigocontribuyente, "string");
      _petition.add_item("resolucionexoneracion", payload.resolucionexoneracion, "string");
      _petition.add_item("fechaadquisicion", payload.fechaadquisicion, "string");
      _petition.add_item("fechainicio", payload.fechainicio, "string");
      _petition.add_item("fechavencimiento", payload.fechavencimiento, "string");

      _petition.add_item("iddomiciliofiscal", payload.iddomiciliofiscal, "int");
      _petition.add_item("idficha", payload.idficha, "int");
      _petition.add_item("identidadtitular", payload.identidadtitular, "int");
      _petition.add_item("identidadjuridica", payload.identidadtitularRuc, "int");
      _petition.add_item("idformaadquisicion", payload.idformaadquisicion, "int");
      _petition.add_item("porcentajecotitular", payload.porcentajecotitular, "int");
      _petition.add_item("idcondicionespecialtitular", payload.idcondicionespecialtitular, "int");
    } else {
      _petition.add_itemFilter("numerocotitular", payload.numerocotitular, "string");
      _petition.add_itemFilter("otroformaadquisicion", payload.otroformaadquisicion, "string");
      _petition.add_itemFilter("codigocontribuyente", payload.codigocontribuyente, "string");
      _petition.add_itemFilter("resolucionexoneracion", payload.resolucionexoneracion, "string");
      _petition.add_itemFilter("fechaadquisicion", payload.fechaadquisicion, "string");
      _petition.add_itemFilter("fechainicio", payload.fechainicio, "string");
      _petition.add_itemFilter("fechavencimiento", payload.fechavencimiento, "string");

      _petition.add_itemFilter("iddomiciliofiscal", payload.iddomiciliofiscal, "int");
      _petition.add_itemFilter("idficha", payload.idficha, "int");
      _petition.add_itemFilter("identidadtitular", payload.identidadtitular, "int");
      _petition.add_itemFilter("identidadjuridica", payload.identidadtitularRuc, "int");
      _petition.add_itemFilter("idformaadquisicion", payload.idformaadquisicion, "int");
      _petition.add_itemFilter("porcentajecotitular", payload.porcentajecotitular, "int");
      _petition.add_itemFilter(
        "idcondicionespecialtitular",
        payload.idcondicionespecialtitular,
        "int"
      );
    }
    
    _petition.type = _type;
    _petition.table = "cat_titular";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  edittitularOneRural: (payload, idtitular) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (idtitular.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idtitularrural = " + idtitular;
    }

    _petition.add_itemFilter("idficha", payload.idficha, "int");
    _petition.add_itemFilter("idtipotitular", payload.idtipotitularres, "int");
    _petition.add_itemFilter("identidadtitular", payload.identidadtitular, "int");
    _petition.add_itemFilter("identidadconyugue", payload.identidadconyugue, "int");
    _petition.add_itemFilter("identidadjuridica", payload.identidadjuridica, "int");
    
    _petition.type = _type;
    _petition.table = "cat_titularrural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editInformacionCotitular: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichacotitularidad";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("otrocondiciondeclarante", payload.otrocondiciondeclarante);
    _petition.add_itemFilter("idcondiciondeclarante", payload.idcondiciondeclarante);
    _petition.add_itemFilter("idestadollenado", payload.idestadollenado);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editInformacionCotitularRural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichacotitularidadrural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("otrocondiciondeclarante", payload.otrocondiciondeclarante);
    _petition.add_itemFilter("idcondiciondeclarante", payload.idcondiciondeclarante, "int");
    _petition.add_itemFilter("idestadollenado", payload.idestadollenado, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneObservacionCotitular: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichacotitularidad";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("observacion", payload.observacion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneObservacionCotitularRural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichacotitularidadrural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("observacion", payload.observacion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },
  /**
   * END FICHA COTITULAR
   */

  /**
   * FICHA RURAL
   */
  getOneFichaRural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_cat_ficharural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneDireccionAddEdit: (payload, iddireccion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "iddireccion = " + iddireccion;

    _petition.type = _type;
    _petition.table = "ads_direccion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemWithNulo("telefono", payload.telefono);
    _petition.add_itemWithNulo("anexo", payload.anexo);
    _petition.add_itemWithNulo("correo", payload.email);
    _petition.add_itemWithNulo("celular", payload.celular);
    _petition.add_itemWithNulo("nombreedificacion", payload.nombreedificacion);
    _petition.add_itemWithNulo("numeromunicipal", payload.numeromunicipal);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editRuralTitular: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("identidadtitular", payload.identidadtitular);
    _petition.add_itemFilter("identidadconyugue", payload.identidadconyugue);
    _petition.add_itemFilter("identidadpersonajuridica", payload.identidadpersonajuridica);

    _petition.add_itemFilter("idtipoentidad", payload.idtipoentidad);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteRuralTitular: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("identidadtitular", "null", "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteRuralConyuge: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("identidadconyugue", "null", "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteRuralJuridica: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("identidadpersonajuridica", "null", "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editUbicacionGeografica: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("nombrepredio", payload.nombrepredio);
    _petition.add_itemFilter("nombrevalle", payload.nombrevalle);
    _petition.add_itemFilter("este", payload.este);
    _petition.add_itemFilter("norte", payload.norte);
    _petition.add_itemFilter("datum", payload.datum);
    _petition.add_itemFilter("zona", payload.zona);
    _petition.add_itemFilter("nombresector", payload.nombresector);
    _petition.add_itemFilter("unidadterritorail", payload.unidadterritorail);
    _petition.add_itemFilter("nombreproyecto", payload.nombreproyecto);
    _petition.add_itemFilter("numerofoto", payload.numerofoto);
    _petition.add_itemFilter("numeroortofoto", payload.numeroortofoto);
    _petition.add_itemFilter("imagensalelital", payload.imagensalelital);
    _petition.add_itemFilter("unidadcatastralanterior", payload.unidadcatastralanterior);
    _petition.add_itemFilter("idubicaciongeografica", payload.idubicaciongeografica);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllCotitularRural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_cat_cotitular");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllCotitularRuralVerificar: (idficha, documento, idcotitular) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_validar_cat_cotitular");
    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("DOCUMENTO", documento);
    _petition.add_item("IDCOTITULAR", idcotitular);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllTitularRural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_select_titular_rural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteDocumentoAdjunto: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "iddocumentoadjunto = " + id;

    _petition.type = _type;
    _petition.table = "cat_documentoadjunto";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneObservacionRural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("observacion", payload.observacion);
    _petition.add_itemFilter("fichaintervencionrepresentante", payload.fichaintervencionrepresentante);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneLitiganteRural: (payload, idlitigante) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (idlitigante.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idlitigante = " + idlitigante;
    } 

    _petition.add_itemFilter("identidad", payload.identidad);
    _petition.add_itemFilter("idficha", payload.idficha);
    _petition.add_itemFilter("codigocontribuyente", payload.codigocontribuyente);
    
    _petition.type = _type;
    _petition.table = "cat_litigante";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllLitigante: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_litigantes_rural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneLitiganteRural: (idlitigante) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idlitigante = " + idlitigante;

    _petition.type = _type;
    _petition.table = "cat_litigante";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");
    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneCrianza: (payload, idexplotacionganaderia) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (idexplotacionganaderia.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idexplotacionganaderia = " + idexplotacionganaderia;
    } 

    _petition.add_itemFilter("cantidad", payload.cantidad);
    _petition.add_itemFilter("idtipoganaderia", payload.idtipoganaderia);

    _petition.type = _type;
    _petition.table = "cat_explotacionganaderia";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("razaespecie", payload.razaespecie);
    _petition.add_itemFilter("idficha", payload.idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllExplotacionGanadera: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_sige_mantenimiento_explotacionganaderia_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneGanaderia: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idriego", payload.idriego);
    _petition.add_itemFilter("idderechousoagua", payload.idderechousoagua);
    _petition.add_itemFilter("idpuentehidrica", payload.idpuentehidrica);
    _petition.add_itemFilter("idcercaniario", payload.idcercaniario);
    _petition.add_itemFilter("cumpleexplotacioneconomica", payload.cumpleexplotacioneconomica);
    _petition.add_itemFilter("otroriego", payload.otroriego);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneExplotacionGanadera: (idexplotacionganaderia) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idexplotacionganaderia = " + idexplotacionganaderia;

    _petition.type = _type;
    _petition.table = "cat_explotacionganaderia";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemWithNulo("eliminado", "1");
    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditExplotacionPredio: (payload, idexplotacionpredio) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (idexplotacionpredio.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idexplotacionpredio = " + idexplotacionpredio;
    }

    _petition.add_itemFilter("idtipocultivo", payload.idtipocultivo);
    _petition.add_itemFilter("areacampo", payload.areacampo);
    _petition.add_itemFilter("areatierra", payload.areatierra);
    _petition.add_itemFilter("area", payload.area);
    _petition.add_itemFilter("idgrupocampo", payload.idgrupocampo);
    _petition.add_itemFilter("idclasecampo", payload.idclasecampo);
    _petition.add_itemFilter("idgrupotierra", payload.idgrupotierra);
    _petition.add_itemFilter("numeroplanta", payload.numeroplanta);
    _petition.add_itemFilter("idclasetierra", payload.idclasetierra);

    _petition.type = _type;
    _petition.table = "cat_explotacionpredio";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("descripcion", payload.descripcion);
    _petition.add_itemFilter("idficha", payload.idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },
  getAllExplotacionPredio: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimientocat_explotacionpredio_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneExplotacionPredio: (idexplotacionpredio) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idexplotacionpredio = " + idexplotacionpredio;

    _petition.type = _type;
    _petition.table = "cat_explotacionpredio";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemWithNulo("eliminado", "1");
    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOnePredioRural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idcodigouso", payload.idcodigouso);
    _petition.add_itemFilter("idclasificacionusoactual", payload.idclasificacionusoactual);
    _petition.add_itemFilter("otroclasificacionusoactual", payload.otroclasificacionusoactual);
    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneViviendaRural: (payload, idviviendaconstruccion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (idviviendaconstruccion.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idviviendaconstruccion = " + idviviendaconstruccion;

      _petition.add_itemWithNulo(
        "idtipoconstruccioninstalacion",
        payload.idtipoconstruccioninstalacion
      );
    } else {
      _petition.add_itemFilter(
        "idtipoconstruccioninstalacion",
        payload.idtipoconstruccioninstalacion
      );
    }

    _petition.type = _type;
    _petition.table = "cat_viviendaconstruccion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("otrotipoconstruccioninstalacion", payload.otrotipoconstruccioninstalacion);
    _petition.add_item("idficha", payload.idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllVivivendaRuralVerificarDuplicados: (idficha, idcatalogo, idvivienda) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_itemFilter("script", "q_seg_mantenimiento_obtener_verificar_cat_viviendaconstruccion");
    _petition.add_itemFilter("IDFICHA", idficha);
    _petition.add_itemFilter("IDCATALOGO", idcatalogo);
    _petition.add_itemFilter("IDVIVIENDA", idvivienda);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllVivivendaRural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimientocat_vivienda_ficha_rural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneViviendaRural: (idviviendaconstruccion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idviviendaconstruccion = " + idviviendaconstruccion;

    _petition.type = _type;
    _petition.table = "cat_viviendaconstruccion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemWithNulo("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOnePredioCaracteristicas: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("areaterreno", payload.areaterreno);
    _petition.add_itemFilter("areadeclarado", payload.areadeclarado);
    // (Se quitó idinscripcionsunarp: esta sección es solo de áreas y lo borraba;
    //  ese campo [50] lo guarda editOnePredioCatastralRural en Condición del Predio.)

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllDocumentoPosesionRural: (idtipodocumentoposesion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_documentoposesion_all");
    _petition.add_item("idtipodocumentoposesion", idtipodocumentoposesion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneCaracteristicaPredio: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "iddocumentosobreposesion = " + id;

    _petition.type = _type;
    _petition.table = "cat_documentosobreposesion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemWithNulo("eliminado", 1);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneDocumentoPosesion: (payload, iddocumentosobreposesion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (iddocumentosobreposesion.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "iddocumentosobreposesion = " + iddocumentosobreposesion;
    } 

    _petition.add_itemFilter("iddocumentoposesion", payload.iddocumentoposesion);
    _petition.add_itemFilter("idtipodocumentoprueba", payload.idtipodocumentoprueba);
    _petition.add_itemFilter("idficha", payload.idficha);

    _petition.type = _type;
    _petition.table = "cat_documentosobreposesion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllDocumentoSobrePosesionRural: (idtipodocumentoposesion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_documentoposesion_all");
    _petition.add_item("idtipodocumentoposesion", idtipodocumentoposesion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllCatDocumentoPosesion: (idficha, idtipodocumentoprueba) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_cat_documentosobreposesion_all");
    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("idtipodocumentoprueba", idtipodocumentoprueba);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllCatDocumentoPosesionVerificar: (
    idficha,
    idtipodocumentoprueba,
    idcatalogo,
    iddocumento
  ) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_verificar_cat_documentosobreposesion_all");
    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("idtipodocumentoprueba", idtipodocumentoprueba);
    _petition.add_item("IDTIPODOC", idcatalogo);
    _petition.add_item("IDDOCUMENTO", iddocumento);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOnePredioCatastralRural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("numeropartidaregistral", payload.numeropartidaregistral);
    _petition.add_itemFilter("otrocondiciontitular", payload.otrocondiciontitular);
    _petition.add_itemFilter("otrodocumentopropiedad", payload.otrodocumentopropiedad);
    _petition.add_itemFilter("iddocumentopropiedad", payload.iddocumentopropiedad);
    _petition.add_itemFilter("idcondiciontitular", payload.idcondiciontitular);
    _petition.add_itemFilter("idinscripcionsunarp", payload.idinscripcionsunarp);
    _petition.add_itemFilter("fechaocupacion", payload.fechaocupacion);
    _petition.add_itemFilter("fechainscripcion", payload.fechainscripcion);
    _petition.add_itemFilter("fechaadquisicion", payload.fechaadquisicion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOnePredioEspecialTitular: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficharural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idcondicionespecialtitular", payload.idcondicionespecialtitular);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneDireccionRural: (payload, iddomiciliofiscaltitular, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var isEdit = iddomiciliofiscaltitular.length > 0;
    var _token = _petition.token;

    // Petición 1: crea (INSERT) o actualiza (UPDATE) la dirección en ads_direccion
    _petition.type = isEdit ? TYPE.UPDATE : TYPE.INSERT;
    _petition.table = "ads_direccion";
    _petition.condition = isEdit ? "iddireccion = " + iddomiciliofiscaltitular : "";
    _petition.transaction = false;

    _petition.add_itemFilter("nombreedificacion", payload.nombreedificacion);
    _petition.add_itemFilter("zona", payload.zona);
    _petition.add_itemFilter("via", payload.via);
    _petition.add_itemFilter("tipovia", payload.tipovia);
    _petition.add_itemFilter("habilitacionurbana", payload.habilitacionurbana);
    _petition.add_itemFilter("idubicaciongeografica", payload.idubicaciongeografica);
    _petition.add_itemFilter("telefono", payload.telefono);
    _petition.add_itemFilter("correo", payload.email);
    _petition.add_itemFilter("celular", payload.celular);
    _petition.add_itemFilter("idvia", payload.idvia, "int");
    _petition.add_itemFilter("numeromunicipal", payload.numeromunicipal);

    _request.petitions.push(_petition);

    // Petición 2: enlaza la dirección a la ficha y guarda la zona en cat_ficharural
    // (la consulta de carga lee f.zona). El _id solo se resuelve al INSERTAR una
    // dirección nueva; al editar ya conocemos el iddireccion, así que NO se usa la
    // acción (evita el error "Undefined array key _id" porque un UPDATE no retorna _id).
    var c_registro = {
      name: "GetNextId",
      token: _token,
      max_length: 11
    };

    _petition = new Petition();
    _petition.type = TYPE.UPDATE;
    _petition.table = "cat_ficharural";
    _petition.condition = "idficha = " + idficha;

    _petition.add_itemFilter(
      "iddomiciliofiscaltitular",
      payload.iddomiciliofiscaltitular,
      "string",
      isEdit ? null : c_registro
    );
    // NOTA: la zona del domicilio fiscal se guarda en ads_direccion (petición 1).
    // NO se escribe en cat_ficharural: ese campo `zona` es el UTM de la sección
    // Ubicación y no debe pisarse desde aquí.

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneCotitularRural: (payload, idcotitular) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (idcotitular.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idcotitular = " + idcotitular;
    } 
      
    _petition.add_itemFilter("identidad", payload.identidad);
    _petition.add_itemFilter("idficha", payload.idficha);

    _petition.type = _type;
    _petition.table = "cat_cotitular";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneCotitularRural: (idcotitular) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idcotitular = " + idcotitular;

    _petition.type = _type;
    _petition.table = "cat_cotitular";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getConstruccionesRuralAll: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_cat_construccion_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneConstruccionesRural: (payload, idconstruccion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (idconstruccion.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idconstruccion = " + idconstruccion;
    }

    _petition.add_itemFilter("areaverificada", payload.areaverificada);
    _petition.add_itemFilter("idestructuramurocolumna", payload.idestructuramurocolumna);
    _petition.add_itemFilter("idestructuratecho", payload.idestructuratecho);
    _petition.add_itemFilter("idacabadopiso", payload.idacabadopiso);
    _petition.add_itemFilter("idacabadopuertaventana", payload.idacabadopuertaventana);
    _petition.add_itemFilter("idacabadorevestimiento", payload.idacabadorevestimiento);
    _petition.add_itemFilter("idacabadobanio", payload.idacabadobanio);
    _petition.add_itemFilter("idinstalacionelectrica", payload.idinstalacionelectrica);
    _petition.add_itemFilter("numeropiso", payload.numeropiso);
    _petition.add_itemFilter("idmaterialestructural", payload.idmaterialestructural);
    _petition.add_itemFilter("idestadoconservacion", payload.idestadoconservacion);
    _petition.add_itemFilter("idestadoconstruccion", payload.idestadoconstruccion);
    _petition.add_itemFilter("fechaconstruccion", payload.fechaconstruccion);
    _petition.add_itemFilter("areadeclarada", payload.areadeclarada);
    _petition.add_itemFilter("idunidadconstruccionantirreglamentaria", payload.idunidadconstruccionantirreglamentaria);
    _petition.add_itemFilter("idficha", payload.idficha);
    
    _petition.type = _type;
    _petition.table = "cat_construccion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteConstruccionesRuralOne: (idconstruccion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idconstruccion = " + idconstruccion;

    _petition.type = _type;
    _petition.table = "cat_construccion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneCaracteristicasRural: (payload, idconstruccioninstalacion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (idconstruccioninstalacion.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idconstruccioninstalacion = " + idconstruccioninstalacion;
    }

    _petition.add_itemFilter("cantidad", payload.cantidad);
    _petition.add_itemFilter("area", payload.area);
    _petition.add_itemFilter("porcentaje", payload.porcentaje);
    _petition.add_itemFilter("volumen", payload.volumen);
    _petition.add_itemFilter("idestadoconstruccion", payload.idestadoconstruccion);
    _petition.add_itemFilter("idestadoconservacion", payload.idestadoconservacion);
    _petition.add_itemFilter("anioconstruccion", payload.anioconstruccion);
    _petition.add_itemFilter("idtipoconstruccioninstalacion",payload.idtipoconstruccioninstalacion);
    _petition.add_itemFilter("idmaterialestructural", payload.idmaterialestructural);
    _petition.add_itemFilter("idficha", payload.idficha);
    _petition.add_itemFilter("otroestadoconstruccion", payload.otroestadoconstruccion);
    _petition.add_itemFilter("otromaterialestructural", payload.otromaterialestructural);
    _petition.add_itemFilter("otrotipoconstruccioninstalacion", payload.otrotipoconstruccioninstalacion);
    
    _petition.type = _type;
    _petition.table = "cat_construccioninstalacion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getCaracteristicasRuralAll: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_cat_construccioninstalacion_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneCaracteristicasRural: (idconstruccioninstalacion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idconstruccioninstalacion = " + idconstruccioninstalacion;

    _petition.type = _type;
    _petition.table = "cat_construccioninstalacion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  /**
   * END FICHA RURAL
   */

  /**
   * FICHA BIEN COMUN
   */

  getOneFichaBienComun: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_datos_cat_fichabiencomun");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllPredioBienComun: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_datos_prediobiencomun");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editPredioCatastralFichaBienComun: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencomun";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("nombreedificacion", payload.nombreedificacion);
    _petition.add_itemFilter("zona", payload.zona);
    _petition.add_itemFilter("manzana", payload.manzana);
    _petition.add_itemFilter("lote", payload.lote);
    _petition.add_itemFilter("sublote", payload.sublote);
    _petition.add_itemFilter("idhabilitacionurbana", payload.idhabilitacionurbana, "int");
    _petition.add_itemFilter("idtipoedificacion", payload.idtipoedificacion, "int");
    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getHabilitacionBusquedaById: (codigo) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_busqueda_habilitacionurbana_all");
    _petition.add_item("CODIGO", codigo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getUsoBusquedaById: (codigo) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_select_uso_all");
    _petition.add_item("IDUSO", codigo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getViaById: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_via_by_idvia");
    _petition.add_item("IDVIA", id);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getViasBusquedaById: (codigo) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_busqueda_via_all");
    _petition.add_item("CODIGO", codigo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getUbicacionPredioCatastraladdEdit: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    var _type = TYPE.INSERT;
    var _condition = "";
    if (payload.idubicacionprediocatastral.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idubicacionprediocatastral = " + payload.idubicacionprediocatastral;
    }

    _petition.add_itemFilter("numeromunicipal", payload.numeromunicipal);
    _petition.add_itemFilter("idvia", payload.idvia);
    _petition.add_itemFilter("idtipopuerta", payload.idtipopuerta);
    _petition.add_itemFilter("idcondicionnumeracion", payload.idcondicionnumeracion);
    _petition.add_itemFilter("numerocertificacion", payload.numerocertificacion);
    _petition.add_itemFilter("idficha", payload.idficha, "int");
    
    _petition.type = _type;
    _petition.table = "cat_ubicacionprediocatastral";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getDescripcionBienComunPredioaddEdit: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencomun";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("areaterrenoadquirido", payload.areaterrenoadquirido);
    _petition.add_itemFilter("areaterrenoverificado", payload.areaterrenoverificado);
    _petition.add_itemFilter("zonificacion", payload.zonificacion);
    _petition.add_itemFilter("estructuracion", payload.estructuracion);
    _petition.add_itemFilter("iduso", payload.iduso);
    _petition.add_itemFilter("idprediocatastral", payload.idprediocatastral);
    _petition.add_itemFilter("idclasificacionpredio", payload.idclasificacionpredio);
    _petition.add_itemFilter("otroclasificacionpredio", payload.otroclasificacionpredio);
    _petition.add_itemFilter("otroprediocatastral", payload.otroprediocatastral);
    _petition.add_itemFilter("frentemedidacampo", payload.frentemedidacampo);
    _petition.add_itemFilter("frentemedidatitulo", payload.frentemedidatitulo);
    _petition.add_itemFilter("frentecolindacampo", payload.frentecolindacampo);
    _petition.add_itemFilter("frentecolindatitulo", payload.frentecolindatitulo);
    _petition.add_itemFilter("derechamedidacampo", payload.derechamedidacampo);
    _petition.add_itemFilter("derechamedidatitulo", payload.derechamedidatitulo);
    _petition.add_itemFilter("derechacolindacampo", payload.derechacolindacampo);
    _petition.add_itemFilter("derechacolindatitulo", payload.derechacolindatitulo);
    _petition.add_itemFilter("izquierdamedidacampo", payload.izquierdamedidacampo);
    _petition.add_itemFilter("izquierdamedidatitulo", payload.izquierdamedidatitulo);
    _petition.add_itemFilter("izquierdacolindacampo", payload.izquierdacolindacampo);
    _petition.add_itemFilter("izquierdacolindatitulo", payload.izquierdacolindatitulo);
    _petition.add_itemFilter("fondomedidacampo", payload.fondomedidacampo);
    _petition.add_itemFilter("fondomedidatitulo", payload.fondomedidatitulo);
    _petition.add_itemFilter("fondocolindacampo", payload.fondocolindacampo);
    _petition.add_itemFilter("fondocolindatitulo", payload.fondocolindatitulo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteCodigoUso: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencomun";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("iduso", "null", "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  GetServiciosBasicosBienComunaddEdit: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencomun";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("numerosuministroluz", payload.numerosuministroluz);
    _petition.add_itemFilter("numerocontratoagua", payload.numerocontratoagua);
    _petition.add_itemFilter("numerotelefono", payload.numerotelefono);

    _petition.add_itemFilter("idluz", payload.idluz, "int");
    _petition.add_itemFilter("idagua", payload.idagua, "int");
    _petition.add_itemFilter("idtelefono", payload.idtelefono, "int");
    _petition.add_itemFilter("iddesague", payload.iddesague, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllByTipoEdificacion: (idtipovaloredificacion) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_busqueda_select_tipoedificacion_all");
    _petition.add_item("IDTIPOVALOREDIFICACION", idtipovaloredificacion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllInstacionesObraBienComun: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_cat_instalacionobra_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditObraComplementariaBienComun: (payload, idinstalacionobra) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";
    if (idinstalacionobra.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idinstalacionobra = " + idinstalacionobra;

    }

    _petition.add_itemFilter("unidadmedida", payload.unidadmedida);
    _petition.add_itemFilter("productototal", payload.productototal);
    _petition.add_itemFilter("idmaterialestructural", payload.idmaterialestructural);
    _petition.add_itemFilter("idestadoconservacion", payload.idestadoconservacion);
    _petition.add_itemFilter("idestadoconstruccion", payload.idestadoconstruccion);
    _petition.add_itemFilter("idunidadconstruccionantirreglamentaria", payload.idunidadconstruccionantirreglamentaria);
    _petition.add_itemFilter("fechaconstruccion", payload.fechaconstruccion);
    _petition.add_itemFilter("idcodigoinstalacion", payload.idcodigoinstalacion);
    _petition.add_itemFilter("idficha", payload.idficha, "int");
    _petition.add_itemFilter("largo", payload.largo);
    _petition.add_itemFilter("alto", payload.alto);
    _petition.add_itemFilter("ancho", payload.ancho);

    _petition.type = _type;
    _petition.table = "cat_instalacionobra";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editInformacionComplementariaBienComun: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencomun";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("observacion", payload.observacion);
    // _petition.add_itemFilter("otrodocumentopresentado", payload.otrodocumentopresentado);
    _petition.add_itemFilter("otrocondiciondeclarante", payload.otrocondiciondeclarante);
    _petition.add_itemFilter("idcondiciondeclarante", payload.idcondiciondeclarante);
    _petition.add_itemFilter("idestadollenado", payload.idestadollenado);
    _petition.add_itemFilter("idmantenimiento", payload.idmantenimiento);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditOneRegistroPredios: (payload, idsunarp) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";
    if (idsunarp.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idsunarp = " + idsunarp;
    }

    _petition.add_itemFilter("numero", payload.numero);
    _petition.add_itemFilter("foja", payload.foja);
    _petition.add_itemFilter("asiento", payload.asiento);
    _petition.add_itemFilter("fechainscripcion", payload.fechainscripcion);
    _petition.add_itemFilter("asientofabrica", payload.asientofabrica);
    _petition.add_itemFilter("iddeclaracionfabrica", payload.iddeclaracionfabrica);
    _petition.add_itemFilter("fechafabrica", payload.fechafabrica);
    _petition.add_itemFilter("idtipopartidaregistral", payload.idtipopartidaregistral);
    _petition.add_itemFilter("idficha", payload.idficha, "int");
    
    _petition.type = _type;
    _petition.table = "cat_sunarp";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllSunarpOne: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_select_sunarp_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllTitularCultural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_select_titular_cultural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllEdificacion: () => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_data_select_edificacion_all");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editRecapitulacionBienComun: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencomun";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("kardex", payload.kardex);
    _petition.add_item("fechaescriturapublica", payload.fechaescriturapublica);
    _petition.add_itemFilter("idmantenimiento", payload.idmantenimiento);
    _petition.add_itemFilter("idnotaria", payload.idnotaria);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editRecapitulacionEdificio: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencomun";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("lotecolidante", payload.lotecolidante);
    _petition.add_itemFilter("jardinaislamiento", payload.jardinaislamiento);
    _petition.add_itemFilter("areapublica", payload.areapublica);
    _petition.add_itemFilter("areintangible", payload.areintangible);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditRecapitulacionBienComun: (payload, id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (id.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idrecapbiencomun = " + id;

    } 

    _petition.add_itemFilter("porcentaje", payload.porcentaje);
    _petition.add_itemFilter("areaterrenocomun", payload.areaterrenocomun);
    _petition.add_itemFilter("areaconstruidacomun", payload.areaconstruidacomun);
    _petition.add_itemFilter("areaotrainstalacioncomun", payload.areaotrainstalacioncomun);
    
    _petition.add_itemFilter("codigoedifica", payload.codigoedifica);
    _petition.add_itemFilter("codigoentrada", payload.codigoentrada);
    _petition.add_itemFilter("codigopiso", payload.codigopiso);
    _petition.add_itemFilter("codigounidad", payload.codigounidad);

    _petition.type = _type;
    _petition.table = "cat_recapbiencomun";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("idficha", payload.idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditRecapitulacionEdificio: (payload, id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (id.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idrecapedificio = " + id;

    }

    _petition.add_itemFilter("porcentaje", payload.porcentaje);
    _petition.add_itemFilter("areaterrenocomun", payload.areaterrenocomun);
    _petition.add_itemFilter("areaconstruidacomun", payload.areaconstruidacomun);
    _petition.add_itemFilter("areaotrainstalacioncomun", payload.areaotrainstalacioncomun);
    
    _petition.add_itemFilter("codigoedifica", payload.codigoedifica);
    _petition.add_itemFilter("idficha", payload.idficha);

    _petition.type = _type;
    _petition.table = "cat_recapedificio";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllRecapitulacionBienComun: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_recapitulacion_bien_comun_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllRecapitulacionEdificio: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_recapitulacion_edificio_all");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  /**
   * END FICHA BIEN COMUN
   */

  /** FICHA BIEN CULTURAL */

  editOnePredioBienCultural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("nombremonumento", payload.nombremonumento);
    _petition.add_itemFilter("codigomonumento", payload.codigomonumento);
    _petition.add_itemFilter("idcategoriainmueble", payload.idcategoriainmueble);
    _petition.add_itemFilter("area", payload.area);
    _petition.add_itemFilter("perimetro", payload.perimetro);
    _petition.add_itemFilter("idfiliacioncronologica", payload.idfiliacioncronologica);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getOneBienCultural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_datos_cat_fichabiencultural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getOneBienCulturalVerificar: (idficha, idtipo, idelemento) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ficha_datos_cat_fichabiencultural_verificar");
    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("IDTIPO", idtipo);
    _petition.add_item("IDELEMENTOARQ", idelemento);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editMaterialBienCultural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idpresenciaarquitectura", payload.idpresenciaarquitectura);
    _petition.add_itemFilter("idtipoarquitectura", payload.idtipoarquitectura);
    _petition.add_itemFilter("idtipomaterialconstructivo", payload.idtipomaterialconstructivo);
    _petition.add_itemFilter("otrotipoarquitectura", payload.otrotipoarquitectura);
    _petition.add_itemFilter("otrotipomaterialconstructivo",payload.otrotipomaterialconstructivo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editConservacionlBienCultural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idafectacionnatural", payload.idafectacionnatural);
    _petition.add_itemFilter("idafectacionantropica", payload.idafectacionantropica);
    _petition.add_itemFilter("idintervencionconservacion", payload.idintervencionconservacion);
    _petition.add_itemFilter("otroafectacionnatural", payload.otroafectacionnatural);
    _petition.add_itemFilter("otroafectacionantropica", payload.otroafectacionantropica);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneRegistroPredioBienCultural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idtipopartidaregistral", payload.idtipopartidaregistral);
    _petition.add_itemFilter("numero", payload.numero);
    _petition.add_itemFilter("foja", payload.foja);
    _petition.add_itemFilter("asiento", payload.asiento);
    _petition.add_itemFilter("fechainscripcionpredio", payload.fechainscripcionpredio);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllNormativaLegal: (idficha, IDTIPOMONUMENTO) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_cat_normallegal_all");
    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("IDTIPOMONUMENTO", IDTIPOMONUMENTO);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneNormaLegal: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idnormalegal = " + id;

    _petition.type = _type;
    _petition.table = "cat_normallegal";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneNormaLegal: (payload, idnormalegal) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";
    if (idnormalegal.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idnormalegal = " + idnormalegal;
    } 

    _petition.add_itemFilter("idtipomonumento", payload.idtipomonumento);
    _petition.add_itemFilter("normatividad", payload.normatividad);
    _petition.add_itemFilter("fecha", payload.fecha);
    _petition.add_itemFilter("numeroplano", payload.numeroplano);
    _petition.add_itemFilter("idficha", payload.idficha, "int");
    
    _petition.type = _type;
    _petition.table = "cat_normallegal";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneObservacionBienCultural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("observacion", payload.observacion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editInformacionComplementariaCultural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idcondiciondeclarante", payload.idcondiciondeclarante);
    _petition.add_itemFilter("idestadollenado", payload.idestadollenado);
    _petition.add_itemFilter("numerofamilia", payload.numerofamilia);
    _petition.add_itemFilter("numerohabitante", payload.numerohabitante);
    _petition.add_itemFilter("otrocondiciondeclarante", payload.otrocondiciondeclarante);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllLitiganteCultural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_obtener_litigantes_cultural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAllLitiganteCulturalVerificar: (idficha, documento, idlitigante) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_obtener_litigantes_cultural_verificar");
    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("DOCUMENTO", documento);
    _petition.add_item("IDLITIGANTE", idlitigante);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneObservacionBienHistorica: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("observacionhistorico", payload.observacion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneInformacionBasicaBienCultural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idinmueblepatrimoniocultural",payload.idinmueblepatrimoniocultural);
    _petition.add_itemFilter("nombremonumentohistorico", payload.nombremonumentohistorico);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOneRegistroPredioBienCulturalHistorica: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idtipopartidaregistralhistorico", payload.idtipopartidaregistral);
    _petition.add_itemFilter("numerohistorico", payload.numero);
    _petition.add_itemFilter("fojahistorico", payload.foja);
    _petition.add_itemFilter("asientohistorico", payload.asiento);
    _petition.add_itemFilter("fechainscripcionprediohistorico", payload.fechainscripcionpredio);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editRuralTitularCultural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("identidadtitular", payload.identidadtitular);
    _petition.add_itemFilter("identidadconyugue", payload.identidadconyugue);
    _petition.add_itemFilter("identidadpersonajuridica", payload.identidadpersonajuridica);
    _petition.add_itemFilter("idtipoentidad", payload.idtipoentidad);
    _petition.add_itemFilter("idcondicionespecial", payload.idcondicionespecial);

    _request.petitions.push(_petition);

    if (payload.identidadpersonajuridica != null && payload.identidadpersonajuridica != "") {
      _condition = "identidad = " + payload.identidadpersonajuridica;
      _petition = new Petition();

      _petition.type = _type;
      _petition.table = "ope_entidad";
      _petition.condition = _condition;
      _petition.transaction = false;

      _petition.add_itemFilter("idtipopersonajuridica", payload.idtipopersonajuridica);

      _request.petitions.push(_petition);
    }

    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editDescripcionBienCultural: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_fichabiencultural";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemFilter("idtipoarquitectura", payload.idtipoarquitectura);
    _petition.add_itemFilter("usoactual", payload.usoactual);
    _petition.add_itemFilter("usooriginal", payload.usooriginal);
    _petition.add_itemFilter("numeropiso", payload.numeropiso);
    _petition.add_itemFilter("fechaconstruccion", payload.fechaconstruccion);
    _petition.add_itemFilter("areaterreno", payload.areaterreno);
    _petition.add_itemFilter("arealibre", payload.arealibre);
    _petition.add_itemFilter("areaconstruida", payload.areaconstruida);
    _petition.add_itemFilter("idfiliacionestilistica", payload.idfiliacionestilistica);
    _petition.add_itemFilter("idintervencioninmueble", payload.idintervencioninmueble);
    _petition.add_itemFilter("descripcionfachada", payload.descripcionfachada);
    _petition.add_itemFilter("descripcioninterior", payload.descripcioninterior);
    _petition.add_itemFilter("reseniahistorica", payload.reseniahistorica);
    _petition.add_itemFilter("idestructuraacabado", payload.idestructuraacabado);

    _petition.add_itemFilter("otrotipoarquitectura", payload.otrotipoarquitectura);
    _petition.add_itemFilter("otrofiliacionestilistica", payload.otrofiliacionestilistica);
    _petition.add_itemFilter("otroestructuraacabado", payload.otroestructuraacabado);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  // getAllMonumentoBienCultural

  getAllMonumentoBienCultural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_elementoarquitectonico");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editOnePatrimonioBienCultural: (payload, idelementoarquitectonico) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";
    if (idelementoarquitectonico.length > 0) {
      _type = TYPE.UPDATE;
      _condition = "idelementoarquitectonico = " + idelementoarquitectonico;
    } 

    _petition.add_itemFilter("otrotipoelementoarquitectonico", payload.otrotipoelementoarquitectonico);
    _petition.add_itemFilter("idtipoelementoarquitectonico", payload.idtipoelementoarquitectonico);
    _petition.add_itemFilter("idficha", payload.idficha, "int");
    
    _petition.type = _type;
    _petition.table = "cat_elementoarquitectonico";
    _petition.condition = _condition;
    _petition.transaction = false;

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneCulturalBienCultural: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idelementoarquitectonico = " + id;

    _petition.type = _type;
    _petition.table = "cat_elementoarquitectonico";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getReporteBienCultural: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_reporte_biencultural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);

    _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_cat_normallegal_all");
    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("IDTIPOMONUMENTO", "1");

    _request.petitions.push(_petition);

    _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_cat_normallegal_all");
    _petition.add_item("IDFICHA", idficha);
    _petition.add_item("IDTIPOMONUMENTO", "2");

    _request.petitions.push(_petition);

    _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_obtener_litigantes_cultural");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);

    _petition = new Petition();

    _petition.add_item("script", "q_syca_mantenimiento_elementoarquitectonico");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);

    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  /** END FICHA BIEN CULTURAL */

  /**
   * GEOSERVER
   */
  getCoordenadas: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_geoserver_obtener_utm_idficha");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_GEOSERVER";

    return post(PATH.API_SERVICE, _request);
  },

  deleteAuncio: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idanuncio = " + id;

    _petition.type = _type;
    _petition.table = "cat_anuncio";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  /**
   * PRINT REPORTE
   */

  /**
   * REPORTE
   */

  /**
   * END REPORTE
   */

  /** GEOSERVER */

  getInformacionByPuntos: (lat, long) => {
    return post(PATH.API_GEOSERVER_BUSCAR, { latitud: lat, longitud: long });
  },

  procesarAnyCoordenadas: (denominacion, tipogeom, idspatial, oldcoordenadas) => {
    return post(PATH.API_GEOSERVER_PROCESAR_COORDENADAS, {
      denominacion: denominacion,
      tipogeom: tipogeom,
      idspatial: idspatial,
      oldcoordenadas: oldcoordenadas
    });
  },

  /** END GEOSERVER */

  getOpcionesByDenominacion: (val) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_reporte_principal_opciones_denominacion");
    _petition.add_item("BUSCAR", val);

    _request.petitions.push(_petition);

    return post(PATH.API_SERVICE, _request);
  },

  getTotalFormalesInformales: () => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_reporte_syca_total_fichas_formales_informales");
    _request.connectTo = "SRVSQL_SYCA";

    _request.petitions.push(_petition);

    return post(PATH.API_SERVICE, _request);
  },

  getEstadisticaTotalFormalesInformales: () => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_estadistica_total_fichas_formales_informales");
    _request.connectTo = "SRVSQL_SYCA";

    _request.petitions.push(_petition);

    return post(PATH.API_SERVICE, _request);
  },

  getValidarDocumento: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.type = 1;
    var _id = -1;

    if (payload.id != "" && payload.id != null) _id = payload.id;

    /**
     * MÉTODO PARA VALIDAR EL CORREO DEL USUARIO
     */

    _petition.add_item("script", "q_seg_mantenimiento_validar_documento_ope_personal");
    _petition.add_item("IDUSUARIO", _id, "int");
    _petition.add_item("DOCUMENTO", payload.documentoregistro);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getValidarDocumentoEntidad: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.type = 1;
    var _id = -1;

    if (payload.id != "" && payload.id != null) _id = payload.id;

    _petition.add_item("script", "q_seg_mantenimiento_validar_documento_ope_entidad");
    _petition.add_item("IDUSUARIO", _id, "int");
    _petition.add_item("DOCUMENTO", payload.documentoregistro);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  changeStateConstanciaNegativoCat: (iddocumento, activo) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "iddocumento = " + iddocumento;

    _petition.type = _type;
    _petition.table = "doc_documento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("activo", activo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  changeStateCoordenadaShapefile: (idtiposhapefile, activo) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idgruposhapefile = " + idtiposhapefile;

    _petition.type = _type;
    _petition.table = "cat_gruposhapefile";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("activo", activo);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneConstanciaNegativoCat: (iddocumento) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "iddocumento = " + iddocumento;

    _petition.type = _type;
    _petition.table = "doc_documento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  deleteOneCoordenadaShapefile: (idtiposhapefile) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idgruposhapefile = " + idtiposhapefile;

    _petition.type = _type;
    _petition.table = "cat_gruposhapefile";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  /**
   * END REPORTE
   */

  getCoordenadasGeoserver: (idficha) => post("/api/ServiceGeoserver/V1/" + idficha),

  addEditConstanciaNegativa: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (payload.id > 0) {
      _type = TYPE.UPDATE;
      _condition = "iddocumento = " + payload.id;

      _petition.add_itemWithNulo("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemWithNulo("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemWithNulo("numeroinforme", payload.numeroinforme);
      _petition.add_itemWithNulo("fechainforme", payload.fechainforme);
      _petition.add_itemWithNulo("idficha", payload.idficha);
    } else {
      _petition.add_itemFilter("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemFilter("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemFilter("numeroinforme", payload.numeroinforme);
      _petition.add_itemFilter("fechainforme", payload.fechainforme);
      _petition.add_itemFilter("idficha", payload.idficha);
    }

    _petition.type = _type;
    _petition.table = "doc_documento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("idtipodocumento", 1, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  // Guarda un documento/certificado en doc_documento con el idtipodocumento indicado.
  // (1=Constancia Negativa, 4=Numeracion, 5=Certificado Catastral, ...)
  addEditDocumentoCertificado: (payload, idtipodocumento) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (payload.id > 0) {
      _type = TYPE.UPDATE;
      _condition = "iddocumento = " + payload.id;

      _petition.add_itemWithNulo("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemWithNulo("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemWithNulo("numeroinforme", payload.numeroinforme);
      _petition.add_itemWithNulo("fechainforme", payload.fechainforme);
      _petition.add_itemWithNulo("idficha", payload.idficha);
      _petition.add_itemWithNulo("identidad", payload.identidad);
      _petition.add_itemWithNulo("numero", payload.numero, "int");
    } else {
      _petition.add_itemFilter("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemFilter("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemFilter("numeroinforme", payload.numeroinforme);
      _petition.add_itemFilter("fechainforme", payload.fechainforme);
      _petition.add_itemFilter("idficha", payload.idficha);
      _petition.add_itemFilter("identidad", payload.identidad);
      _petition.add_itemFilter("numero", payload.numero, "int");
    }

    _petition.type = _type;
    _petition.table = "doc_documento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("idtipodocumento", idtipodocumento, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditCoordenadas: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (payload.id > 0) {
      _type = TYPE.UPDATE;
      _condition = "idgruposhapefile = " + payload.id;

      _petition.add_itemWithNulo("idspatial", payload.idspatial);
      _petition.add_itemWithNulo("idtipogeom", payload.idtipogeom);
    } else {
      _petition.add_itemFilter("idspatial", payload.idspatial);
      _petition.add_itemFilter("idtipogeom", payload.idtipogeom);
    }

    _petition.type = _type;
    _petition.table = "cat_gruposhapefile";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("denominacion", payload.denominacion);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditConstanciaPosesion: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (payload.id > 0) {
      _type = TYPE.UPDATE;
      _condition = "iddocumento = " + payload.id;

      _petition.add_itemWithNulo("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemWithNulo("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemWithNulo("numeroinforme", payload.numeroinforme);
      _petition.add_itemWithNulo("fechainforme", payload.fechainforme);
      _petition.add_itemWithNulo("idficha", payload.idficha);
    } else {
      _petition.add_itemFilter("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemFilter("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemFilter("numeroinforme", payload.numeroinforme);
      _petition.add_itemFilter("fechainforme", payload.fechainforme);
      _petition.add_itemFilter("idficha", payload.idficha);
    }

    _petition.type = _type;
    _petition.table = "doc_documento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("idtipodocumento", 2, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditCertificadoPosesion: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (payload.id > 0) {
      _type = TYPE.UPDATE;
      _condition = "iddocumento = " + payload.id;

      _petition.add_itemWithNulo("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemWithNulo("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemWithNulo("numeroinforme", payload.numeroinforme);
      _petition.add_itemWithNulo("fechainforme", payload.fechainforme);
      _petition.add_itemWithNulo("idficha", payload.idficha);
      _petition.add_itemWithNulo("anioposesionario", payload.anioposesionario);
    } else {
      _petition.add_itemFilter("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemFilter("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemFilter("numeroinforme", payload.numeroinforme);
      _petition.add_itemFilter("fechainforme", payload.fechainforme);
      _petition.add_itemFilter("idficha", payload.idficha);
      _petition.add_itemFilter("anioposesionario", payload.anioposesionario);
    }

    _petition.type = _type;
    _petition.table = "doc_documento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("idtipodocumento", 3, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addEditCertificadoNumeracion: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (payload.id > 0) {
      _type = TYPE.UPDATE;
      _condition = "iddocumento = " + payload.id;

      _petition.add_itemWithNulo("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemWithNulo("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemWithNulo("numeroinforme", payload.numeroinforme);
      _petition.add_itemWithNulo("fechainforme", payload.fechainforme);
      _petition.add_itemWithNulo("idficha", payload.idficha);
    } else {
      _petition.add_itemFilter("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemFilter("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemFilter("numeroinforme", payload.numeroinforme);
      _petition.add_itemFilter("fechainforme", payload.fechainforme);
      _petition.add_itemFilter("idficha", payload.idficha);
    }

    _petition.type = _type;
    _petition.table = "doc_documento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("idtipodocumento", 4, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  // Certificado de Autorización y Licencias (Licencia de Edificación).
  // Reutiliza doc_documento con idtipodocumento = 6.
  addEditCertificadoAutLic: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    if (payload.id > 0) {
      _type = TYPE.UPDATE;
      _condition = "iddocumento = " + payload.id;

      _petition.add_itemWithNulo("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemWithNulo("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemWithNulo("numeroinforme", payload.numeroinforme);
      _petition.add_itemWithNulo("fechainforme", payload.fechainforme);
      _petition.add_itemWithNulo("observacion", payload.observacion);
      _petition.add_itemWithNulo("idficha", payload.idficha);
    } else {
      _petition.add_itemFilter("fechacomprobante", payload.fechacomprobante);
      _petition.add_itemFilter("numerocomprobante", payload.numerocomprobante);
      _petition.add_itemFilter("numeroinforme", payload.numeroinforme);
      _petition.add_itemFilter("fechainforme", payload.fechainforme);
      _petition.add_itemFilter("observacion", payload.observacion);
      _petition.add_itemFilter("idficha", payload.idficha);
    }

    _petition.type = _type;
    _petition.table = "doc_documento";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("idtipodocumento", 6, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getAreaPerimetro: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_obtener_area_perimetro_lote");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_GEOSERVER";

    return post(PATH.API_SERVICE, _request);
  },

  getFichasEnlazadas: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_codigounico_by_idficha");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getFichasObtenerEstado: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_firmado_ficha");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getFcihaObtenerTotalFichaEconomica: (sector, manzana, lote) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_obtener_total_cat_fichaeconomica");
    _petition.add_item("SECTOR", sector);
    _petition.add_item("MANZANA", manzana);
    _petition.add_item("LOTE", lote);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getFcihaObtenerTotalFichaCotitular: (sector, manzana, lote) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_obtener_total_cat_fichacotitular");
    _petition.add_item("SECTOR", sector);
    _petition.add_item("MANZANA", manzana);
    _petition.add_item("LOTE", lote);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getFcihaObtenerTotalFichaBienComun: (sector, manzana, lote) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_obtener_total_cat_fichabiencomun");
    _petition.add_item("SECTOR", sector);
    _petition.add_item("MANZANA", manzana);
    _petition.add_item("LOTE", lote);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getParametroFirma: () => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_parametros_by_firmas");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL"; // apunta a syse_segu_v2

    return post(PATH.API_SERVICE, _request);
  },

  getFcihasArchivosSys: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_seg_mantenimiento_archivos_sys");
    _petition.add_item("IDFICHA", idficha);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  guardarImagenDocumento: (
    id,
    denominacion,
    extension,
    tamanio,
    ruta,
    tipoarchivo,
    token,
    estado
  ) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.type = 2;
    _petition.table = "rep_archivo";

    _petition.add_item("denominacion", denominacion);
    _petition.add_item("extension", extension);
    _petition.add_item("tamanio", tamanio);
    _petition.add_item("ruta", ruta);
    _petition.add_item("tipoarchivo", tipoarchivo);
    _petition.add_item("token", token);
    _petition.add_item("estado", estado);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";
    return post(PATH.API_SERVICE, _request);
  },

  guardarDocumentoFicha: (id, iddocumento, extension, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.type = 2;
    _petition.table = "cat_archivo";

    _petition.add_itemNulo("idreparchivo", iddocumento, "int");
    _petition.add_itemNulo("idficha", idficha, "int");

    if (extension == "pdf") _petition.add_itemNulo("idtipoarchivo", 1, "int");
    else _petition.add_itemNulo("idtipoarchivo", 2, "int");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";
    return post(PATH.API_SERVICE, _request);
  },

  deleteDocumento: (idarchivo) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idarchivo = " + idarchivo;

    _petition.type = _type;
    _petition.table = "cat_archivo";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("eliminado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  editCoordenadaShapefile: (id, tabla, object) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = 5;
    var _condition = "id = " + id;

    _petition.type = _type;
    _petition.table = tabla;
    _petition.condition = _condition;
    _petition.transaction = false;

    object.forEach((element) => {
      _petition.add_itemWithNulo(element.key, element.value);
    });

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_GEOSERVER";

    return post(PATH.API_SERVICE, _request);
  },

  addEditGeoserverLoteManzanaSector: (payload) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.type = 5;
    _petition.table = "utm_84_lotes";
    _petition.condition = "gid = " + payload.idlote;
    _petition.transaction = false;

    _petition.add_itemWithNulo("idficha", payload.idficha);
    _petition.add_itemWithNulo("isformal", payload.isformal);
    _petition.add_itemWithNulo("tipoficha", payload.tipoficha);
    _petition.add_itemWithNulo("islitigio", payload.islitigio);
    _petition.add_itemWithNulo("codhaburbana", payload.codhaburbana);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_GEOSERVER";

    return post(PATH.API_SERVICE, _request);
  },


  getLeyendaPlanoCatastral: () => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_leyenda");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getDetalleShapefile: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_coordenadas_shapefile_detalle");
    _petition.add_item("ID", id);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  updateFichaEstado: (idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.UPDATE;
    var _condition = "idficha = " + idficha;

    _petition.type = _type;
    _petition.table = "cat_ficha";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_itemWithNulo("firmado", "1");

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  addRegistroFicha: (payload, idficha) => {
    var _request = new ClientRequest();
    var _petition = new Petition();
    var _type = TYPE.INSERT;
    var _condition = "";

    _petition.type = _type;
    _petition.table = "cat_rectificacion";
    _petition.condition = _condition;
    _petition.transaction = false;

    _petition.add_item("denominacion", payload.denominacion);
    _petition.add_item("descripcion", payload.descripcion);
    _petition.add_item("idficha", idficha);

    _request.petitions.push(_petition);

    _petition = new Petition();
    _petition.type = 3;
    _petition.condition = "idficha = " + idficha;
    _petition.table = "cat_ficha";

    _petition.add_item("firmado", 0);
    _request.petitions.push(_petition);

    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getUbicacionGeograficaById: (idubicaciongeografica) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_obtener_ubicaciongeografica_all");
    _petition.add_item("IDUBICACIONGEOGRAFICA", idubicaciongeografica);

    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },

  getDatosVerDocumento: (id) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "q_syca_ver_documento");
    _petition.add_item("IDARCHIVO", id);
    _request.petitions.push(_petition);
    _request.connectTo = "SRVSQL_SYCA";

    return post(PATH.API_SERVICE, _request);
  },
};
